export default __webpack_public_path__ + "static/media/icon-delete-white.d721621a.svg";